// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from 'E:/examination/Admin-TourneyX-Front/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import HomeOutlined from 'E:/examination/Admin-TourneyX-Front/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/HomeOutlined';
import UserOutlined from 'E:/examination/Admin-TourneyX-Front/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/UserOutlined';
export default { SmileOutlined, HomeOutlined, UserOutlined };
